<template>
  <!-- Search Filter -->
  <div class="row filter-row" style="display: flex; justify-content: space-between">
    <div class="col-sm-3">
      <div class="input-block mb-3 form-focus">
        <div class="cal-icon">
            <date-picker
            v-model="startDate"
            placeholder="Start Date"
            class="form-control floating datetimepicker"
            :editable="true"
            :clearable="false"
            :input-format="dateFormat"
            @update:model-value="onSearchClick"
          />
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="input-block mb-3 form-focus">
        <div class="cal-icon">
          <date-picker
              v-model="endDate"
              placeholder="End Date"
              class="form-control floating datetimepicker"
              :editable="true"
              :clearable="false"
              :input-format="dateFormat"
              @update:model-value="onSearchClick"
          />
        </div>
      </div>
    </div>
<!--    <div class="col-sm-3">-->
<!--      <div class="input-block mb-3 form-focus select-focus">-->
<!--        <vue-select :options="Year" id="year-one" placeholder="-" />-->
<!--        <label class="focus-label">Select Year</label>-->
<!--      </div>-->
<!--    </div>-->
  </div>
  <!-- /Search Filter -->
</template>
<script>
import {currentMonthStart, dateRangeEnd} from "@/utils/util-var";
export default {
  data() {
    return {
      select2: null,
      startDate: currentMonthStart,
      endDate: dateRangeEnd,
      dateFormat: 'dd/MM/yyyy',
    };
  },
  methods:{
    onSearchClick(){
      this.$emit("searchClicked",{
        start_date:this.startDate,
        end_date:this.endDate,
      });
    }
  }
};
</script>
